<template>
    <KvInput type="text" v-model="value" :placeholder="label" :name="name" :id="inputId">
        <template #prepend>
            <Icon icon-class="ui-search-01" size="2" />
        </template>
        <template #append>
            <span v-if="removable" class="kv-remove-filter" @click.stop="$emit('remove')">
                <Icon icon-class="ui-x-close" size="2" color="#212529" />
            </span>
        </template>
    </KvInput>
</template>
<style lang="less">
.kv-remove-filter {
    cursor: pointer;
    display: flex;
}
</style>
<script>
import debounce from "../../../helpers/debounce";
import Icon from "../../icon/icon.vue";
import KvInput from "../../inputs/kv-input";
export default {
    name: "kv-textfield",
    components: {
        KvInput,
        Icon
    },
    props: {
        name: {
            type: String,
            default: "textfield",
        },
        label: {
            type: String,
            default: "",
        },
        currentValue: {
            type: String,
            default: "",
        },
        removable: Boolean,
    },
    data() {
        return {
            value: this.currentValue ?? "",
        };
    },
    computed: {
        inputId() {
            return `filter-${this.name}`;
        },
    },
    methods: {
        changed: debounce(
            function () {
                this.$emit("changed", this.value);
            },
            1000,
            false,
        ),
    },
    watch: {
        currentValue(newValue) {
            this.value = newValue;
        },
        value() {
            this.changed();
        },
    },
};
</script>
